'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const designSystem = require('@zapier/design-system');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const ComboBoxClearButtonStyles = react.css({
  display: "flex",
  padding: `var(--zds-space-8, 8px) var(--zds-space-4, 4px)`,
  fontSize: "0",
  background: `var(--zds-background-weaker, ${designSystem.Colors.PrimeWhite})`,
  border: "none",
  borderRadius: `var(--zds-radius-default, 4px)`,
  cursor: "pointer",
  outline: "none",
  '&[data-size="compact"], &[data-size="medium"]': {
    padding: `var(--zds-space-4, 4px)`
  },
  "&[data-hovered] span": {
    fill: `var(--zds-text-weaker, ${designSystem.Colors.GrayWarm9})`
  },
  "&[data-pressed] span": {
    fill: `var(--zds-text-default, ${designSystem.Colors.GrayWarm10})`
  },
  "&[data-focus-visible] span": {
    borderRadius: "50%",
    outline: `2px solid var(--zds-ui-primary, ${designSystem.Colors.UiPrimaryStrongest})`,
    outlineOffset: "-2px"
  }
});
const IconRightWrapperStyles = react.css({
  position: "absolute",
  top: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: `var(--zds-size-40, 40px)`,
  height: `var(--zds-size-large, 44px)`,
  color: `var(--zds-stroke-stronger, ${designSystem.Colors.GrayWarm6})`,
  '&[data-size="compact"], &[data-size="medium"]': {
    width: `var(--zds-size-medium, 36px)`,
    height: `var(--zds-size-medium, 36px)`
  }
});
const TypeaheadRightSlot = (props) => {
  const { iconRight, size } = props;
  const state = React.useContext(reactAriaComponents.ComboBoxStateContext);
  const showClearSelectionButton = state === null || state === void 0 ? void 0 : state.inputValue;
  return react.jsx(React__default.default.Fragment, null, showClearSelectionButton ? react.jsx(
    "div",
    { css: IconRightWrapperStyles, "data-size": size, "data-zds": true },
    react.jsx(
      reactAriaComponents.Button,
      {
        "aria-label": "Clear selection",
        css: ComboBoxClearButtonStyles,
        "data-size": size,
        "data-zds": true,
        onPress: () => state === null || state === void 0 ? void 0 : state.setSelectedKey(null),
        // Don't inherit default RAC Button behavior from RAC ComboBox.
        slot: null
      },
      react.jsx(designSystem.Icon, { name: "formXCircle", color: "GrayWarm6", size: "24px" })
    )
  ) : iconRight && react.jsx(
    "div",
    { css: IconRightWrapperStyles, "data-size": size, "data-zds": true },
    react.jsx(designSystem.Icon, { name: iconRight, size: "24px" })
  ));
};

exports.TypeaheadRightSlot = TypeaheadRightSlot;
//# sourceMappingURL=TypeaheadRightSlot.cjs.js.map
